module.exports = __webpack_public_path__ + "d7d0faffb4cff28276cf92e2d8c9cfe1.png";